import { useQuery } from '@tanstack/react-query';

import AxiosAgent from '@/lib/axios-agent-instance';
import useOnboardingData from '@/store/onboarding-data';

export const getAllChatRequests = async (storeId: string) => {
  try {
    const response = await AxiosAgent.get(`/chat-requests?store_id=${storeId}`);
    return response.data;
  } catch (error: any) {
    if (error.response) {
      throw new Error(
        `${error.response.data?.meta?.message || 'An error occurred'}`,
      );
    }
    throw new Error(error.message || 'Network Error');
  }
};

export const useGetAgentChatRequests = () => {
  const { storeData } = useOnboardingData()
  const sessions = useQuery({
    queryKey: ['get_all_agent_chat_requests'],
    queryFn: () => getAllChatRequests(storeData?.id),
  });

  return sessions;
};
